import { cx } from "../cx";

/** "9+" above `max`, empty at 0 (FE-01 FR-FE01-25, FE-03 formatCount). */
export function formatCount(count: number, max = 9): string {
  if (count <= 0) return "";
  return count > max ? `${max}+` : String(count);
}

export interface CountBadgeProps {
  count: number;
  max?: number;
  className?: string;
}

/** Brand pill at an icon's corner. The number is aria-hidden: the parent carries the label. */
export function CountBadge({ count, max = 9, className }: CountBadgeProps) {
  const text = formatCount(count, max);
  if (!text) return null;
  return (
    <span
      aria-hidden="true"
      className={cx(
        "min-w-4 rounded-full bg-primary px-1.5 text-center text-xs leading-4 font-bold text-on-primary",
        className,
      )}
    >
      {text}
    </span>
  );
}
